export type GetDigitalDocuments = {
  referral_external_id: string;
  bank_digital_documents: BankDigitalDocuments[];
};
export type GetDigitalBankApplicationRequest = {
  opportunityExternalId: string;
};
export type GetDigitalBankApplicationResponse = {
  digital_bank_applications: BankDigitalDocuments[];
};
export type GenerateDigitalBankApplication = {
  opportunityExternalId: string;
  bankApplicationExternalId: string;
};

export type SendDigitalBankApplicationRequest = {
  opportunityExternalId: string;
  bankApplicationExternalId: string;
  digitalDocumentId: string;
};

export type SendDigitalBankApplicationResponse = {
  url?: string | null;
  admin_link?: string | null;
  co_link?: string | null;
  main_link?: string | null;
  main_signer_link?: string | null;
  co_signer_link?: string | null;
};

export type BankDigitalDocuments = {
  bank_application_external_id: string;
  bank_external_id: string;
  bank_name: string;
  bank_logo: string;
  bank_rate: any;
  document: DigitalDocument | null;
};

export const DIGITAL_BANK_APPLICATION_DOCUMENT_STATUS = {
  UPLOADED: 'uploaded',
  DRAFT: 'draft',
  SENT: 'sent',
  VIEWED: 'viewed',
  PAID: 'paid',
  COMPLETED: 'completed',
  VOIDED: 'voided',
  DECLINED: 'declined',
} as const;

export type DigitalBankApplicationDocumentStatusType =
  (typeof DIGITAL_BANK_APPLICATION_DOCUMENT_STATUS)[keyof typeof DIGITAL_BANK_APPLICATION_DOCUMENT_STATUS];

export type DigitalBankApplicationLinks = {
  admin_link: string | null;
  co_link: string | null;
  main_link: string | null;
  main_signer_link: string | null;
  co_signer_link: string | null;
};

export type DigitalDocument = {
  external_id: string | null;
  link?: string | null;
  links?: DigitalBankApplicationLinks;
  status?: DigitalBankApplicationDocumentStatusType;
};
